import React from "react";

export default function TwitterIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2825 14.1623L27.2165 4H25.099L17.3437 12.8234L11.1465 4H4L13.3699 17.344L4 28H6.11749L14.3087 18.6811L20.8535 28H28L18.2825 14.1623ZM15.3833 17.4606L14.4339 16.132L6.87979 5.56H10.1319L16.2267 14.092L17.1761 15.4206L25.1008 26.512H21.8487L15.3833 17.4606Z"
        fill="#EF60A3"
      />
    </svg>
  );
}
